import { useContext, useEffect, useState } from "react";
import SearchFormContent from "../../components/view/hotel/search-form-content";
import { LocaleContext } from "../../routing/LangRouter";
import { Grid } from "@mui/material";

function AccommodationSearch({ isHotelInternational, type }) {
    const { locale } = useContext(LocaleContext);
    const [uid, setUid] = useState();
    const [requestFlag, setRequestFlag] = useState(false);

    useEffect(() => {
        const updatedInfo = {
            isTicket: false,
            isAccommodation: true,
            isItinerary: false,
            isHotelInternational: false,
        };

        sessionStorage.setItem("generalInformation", JSON.stringify(updatedInfo));
    }, []);

    return (
        <Grid className="hotel" container>
            <Grid className="hotel__form" container item xs={12} rowGap={2.5} justifyContent={{ xs: "space-between", md: "flex-start" }}>
                <SearchFormContent
                    setRequestFlag={setRequestFlag}
                    setUid={setUid}
                    isHotelInternational={isHotelInternational}
                    hotelRoute={`/${locale}/hotel`}
                    type={type}
                />
            </Grid>
        </Grid>
    );
}

export default AccommodationSearch;
